export enum RemoteId {
  BlogPostsFolder = 282712,
}

